/*
 *
 * Date: 2025
 * Description: Log box for all scripts logs, permits to select wich script to see its logs
 * Author: Philippe Leroux @SKITSC
 *
 */


//Modules
import { Box, Typography } from "@mui/material"
import { ReactElement } from "react";

//Utils
import { timestampToDate } from "../../utils/utility";

//Interfaces
import { i_script_info } from "../../interfaces/utility.interface";
import { i_active_log_props } from "../../interfaces/display.interfaces";

const ActiveLogBox = ( props : i_active_log_props) : ReactElement => {
    const findScript = () => {
        const script = props.data.find((script : any) => script.pid === props.selected )
        if(script === undefined){
            return { data : []}
        }
        return script
    }
    const scriptTitle = { border : '1px solid black' , borderRadius : '8px', padding : '8px 12px 8px 12px' , backgroundColor : '#f2f2f2' , cursor : 'pointer' , fontSize : 22  }
    const scriptCursorBox = { display: 'flex', overflowX: 'auto', fontWeight : '800', borderBottom : '1px solid black', whiteSpace: 'nowrap', scrollbarWidth: 'thin', '&::-webkit-scrollbar': { height: '6px', }, '&::-webkit-scrollbar-thumb': { backgroundColor: '#888', borderRadius: '3px', }, '&::-webkit-scrollbar-thumb:hover': { backgroundColor: '#555', }, '&::-webkit-scrollbar-track': { backgroundColor: 'transparent', }, }
    return (
        <Box>
            <Box sx={{ display : 'flex' , flexDirection : 'column' }}>
                {props.data.length > 0 ? 
                <>
                    <Box sx={scriptCursorBox}>
                        {props.data.map((script : any, index : number) => (
                            <Box key={index} sx={[scriptTitle , { backgroundColor :  props.selected === script.pid ? '#999' : 'initial'} ]} onClick={() => props.setSelected(script.pid)}>{script.type + " : " + script.pid }</Box>
                        ))}
                    </Box>
                    {props.selected !== null &&
                        <Box sx={{ height : '300px' , overflowY : 'scroll' , backgroundColor : '#111'}}>
                            {
                            findScript().data.map((log: i_script_info, index: number) => (
                                    <Box key={index} sx={{ padding : '4px 8px' , color : log.event === 'data' ? 'lime' : log.event === 'error' ? 'red' : 'orange' }}>{log.msg} - {timestampToDate( log.time , 'short' )}</Box>
                                ))
                                
                            }
                        </Box>
                    }
                </>
                :
                <Box>
                    <Typography>No active script running actually..</Typography>
                </Box>
                }
            </Box>
        </Box>
    )
}


export default ActiveLogBox;